import React, {useState} from 'react'
import {Link, graphql} from 'gatsby'
import Img from 'gatsby-image'
import Layout from '../components/layout'
import PageHeading from '../components/pageheading'
import Phone from '../components/vectors/phone'
import Email from '../components/vectors/email'
import WhatsApp from '../components/vectors/whatsapp'
import '../styles/global.scss'
import CustomerAdviser from '../components/vectors/CustomerAdviser'

export default function Contact({data}){

  const [formState, setFormState] = useState({
    name:'',
    email:'',
    subject:'',
    message:''
  })

const {name, email, subject, message} = formState


const handleChange = e => {
  setFormState({...formState, [e.target.name]:e.target.value})
}


    return(
    <Layout>
    <div className="contact">
    <PageHeading heading='Contact Us'/>
    <div className='contact-main-wrapper'>
    <div className='img-right'>
<Img className='warehouseworker' fluid={data.smilingWarehouseWorker.childImageSharp.fluid} alt='smiling warehouse worker' />
</div>

<div className="main-para">
    <h2>24 / 7 / 365 Availability</h2>
    <p>We endeavour to make all of our customers happy and satisfied with our service. <Link to="/quote_request">For any quote requests please click here</Link>.</p>
    <p>For any enquiries, issues, or questions you may wish to raise with us you can get in contact with us by using one of the methods outlined below.</p>
</div>
</div>

<div className='contact-methods'>

<div className="contact-method">

<Phone className='method-img'/>
<p>Telephone</p>
<a href="tel:+44333 4040 224">0333 4040 224</a>

</div>
<div className="contact-method">
<a href="mailto:contact@haslamlogistics.co.uk" aria-label="Send an email to us"><Email className='method-img'/></a>
<p>Email</p>
<a href="mailto:contact@haslamlogistics.co.uk" >Contact@HaslamLogistics.co.uk</a>
</div>
<div className="contact-method">

<WhatsApp className='method-img'/>
<p>WhatsApp Business</p>
<p>07789 420011</p>

</div>

<div className="contact-method">

<CustomerAdviser className='method-img'/>
<p>Live chat</p>
<p>Click on icon at <br/>the bottom right of the screen.</p>

</div>
    
</div>
<div className="form-wrapper">
        <form data-netlify='true' netlify-honeypot action='/success' method='post' name='contact-form'>
        <h4>Contact Form</h4>
            <div>
            <p className='required-notice'>Fields marked with '<span>*</span>' are required</p>

            <input type="hidden" name="form-name" value="contact-form" />
            <label htmlFor="name">Name of business or individual<span>*</span></label>
            <input type="text" name='name' onChange={handleChange} value={name} required/>
        
            <label htmlFor="email">Email address<span>*</span></label>
            <input type="email" name='email' onChange={handleChange} value={email} required/>
        
            <label htmlFor="subject">Subject</label>
            <input type="text" name='subject' onChange={handleChange} value={subject}/>
        
            <label htmlFor="message">Message<span>*</span></label>
            <textarea name='message'  onChange={handleChange} value={message} required></textarea>
        
            <button className='submit' type='submit'>Submit</button>
            </div>
        </form>
        </div>

    </div>



    </Layout>
        
    )
}

export const query = graphql`
  {
    smilingWarehouseWorker: file(relativePath: {eq: "Smiling warehouse worker.jpg"}) {
      childImageSharp {
        fluid (maxWidth:500){
         ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
  `